import React from 'react';
import clsx from 'clsx';

import CustomSwitch from '@/components/common-components/CustomSwitch/CustomSwitch';
import CustomTooltip from '@/components/common-components/CustomTooltip/CustomTooltip';
import ProfileChip from '@/components/Dashboard/home/components/ProfileChip/ProfileChip';

interface Props {
  mode: string;
  status: string;
  setShowPauseWarning: React.Dispatch<React.SetStateAction<boolean>>;
  showShadow: boolean;
  setStatus: React.Dispatch<React.SetStateAction<string>>;
  title: string;
  profile_pic?: string;
  influencerName?: string;
  showProfileChip?: boolean;
  showBottomBorder?: boolean;
  retry?: boolean;
}

const AutomationHeader: React.FC<Props> = ({
  mode,
  status,
  setStatus,
  setShowPauseWarning,
  showShadow,
  title,
  profile_pic,
  influencerName,
  showProfileChip = false,
  showBottomBorder = true,
  retry = false,
}) => {
  if (retry) {
    return <div className={clsx('text-lg font-medium text-default text-center p-6 m-0')}>Retry Payment</div>;
  }

  if (mode === 'create') {
    return (
      <div
        className={clsx('flex flex-between items-center p-6 m-0', {
          'shadow-down': showShadow,
          center: !showProfileChip,
          'border-b-default': showBottomBorder,
        })}>
        <h1 className={clsx('text-lg font-medium text-default text-center m-0', { 'w-full': !showProfileChip })}>
          {title}
        </h1>
        {showProfileChip && (
          <ProfileChip
            profileLink={profile_pic || ''}
            name={influencerName || ''}
            avatarSize={32}
            stringLength={12}
            className="text-subdued p-1"
          />
        )}{' '}
      </div>
    );
  }
  if (mode === 'edit') {
    return (
      <div
        className={clsx('text-lg font-medium text-default flex flex-between items-center p-6 m-0', {
          'shadow-down': showShadow,
          'border-b-default': showBottomBorder,
        })}>
        Edit Automation{' '}
        <CustomTooltip title={status === 'active' ? 'Pause Automation' : 'Resume Automation'}>
          <div>
            <CustomSwitch
              value={status === 'active'}
              onChange={() => {
                if (status === 'active') {
                  setShowPauseWarning(true);
                } else {
                  setStatus('active');
                }
              }}
            />
          </div>
        </CustomTooltip>
      </div>
    );
  }
  return <></>;
};

export default AutomationHeader;
